export const FinanceSettingsTab = {
    BANK_ACCOUNTS: 0,
    INVOICE_SETTINGS: 1,
    TRANSACTION_CATEGORY: 2,
    BUSINESS_YEAR: 3,
    CONTRACT_STATUS: 4,
    CONTRACT_PART_STATUS: 5,
}